import Loadable from 'app/components/Loadable';
import { lazy } from 'react';

const UnderMaintenance = Loadable(lazy(() => import('./UnderMaintenance')));
const PrivacyPolicy = Loadable(lazy(() => import('./privacypolicy')));
const NotFound = Loadable(lazy(() => import('./NotFound')));
const ForgotPassword = Loadable(lazy(() => import('./ForgotPassword')));
const JwtLogin = Loadable(lazy(() => import('./login/JwtLogin')));
const JwtRegister = Loadable(lazy(() => import("./register/JwtRegister")));

const sessionRoutes = [
  {
    path: '/session/signup',
    element: <JwtRegister />,
  },
  {
    path: '/session/signin',
    element: <JwtLogin />,
  },
  {
    path: '/session/forgot-password',
    element: <ForgotPassword />,
  },
  {
    path: '/session/404',
    element: <NotFound />,
  },
  {
    path: '/under-maintenance',
    element: <UnderMaintenance />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
  },
];

export default sessionRoutes;
